<template>
    <div>
        <div class="header-return">

            <el-button type="text" icon="el-icon-arrow-left" @click="returnHistory">返回</el-button>

        </div>
        <el-form :model="form" label-width="150px">
            <el-form-item label="linkId" :hidden="true">
                <el-input v-model=form.linkId></el-input>
            </el-form-item>
            <el-form-item label="平台">
                <el-select v-model="form.platformId" placeholder="平台" :disabled="platformDisabled">
                    <el-option v-for="item in platformData"
                               :key="item.platformId"
                               :label="item.platformName"
                               :value="item.platformId">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="页面名称">
                <el-input v-model=form.pageTitle clearable placeholder="页面名称" :required="true"></el-input>
            </el-form-item>
            <el-form-item label="页面连接" :required="true">
                <el-input v-model=form.pageLink clearable :disabled="!canEdit"
                          placeholder="示例:pages/home/index"></el-input>
            </el-form-item>
            <el-form-item label="url参数">
                <el-input v-model=form.pageLinkPara clearable
                          placeholder="示例:productId={productId}&productType=1"></el-input>
            </el-form-item>
            <el-form-item label="页面类型" :required="true" v-show="form.activeType==-1">
                <el-select v-model="form.linkTpye" @change="linkTpyeChange()" clearable filterable placeholder="页面类型">
                    <el-option v-for="item in typeList"
                               :key="item.id"
                               :label="item.name"
                               :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="活动类型" :required="true"  v-show="form.linkTpye==0">
                <el-select v-model="form.activeType" @change="activeTypeChange()" clearable filterable placeholder="选择活动类型">
                    <el-option
                            v-for="item in activeTypeList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="活动默认首页" :required="true" v-show="form.activeType>=0">
                <el-select v-model="form.defaultPage" clearable filterable placeholder="活动默认首页">
                    <el-option
                            v-for="item in pageTypeList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="备注" :required="true">
                <el-input v-model=form.remark clearable placeholder="记录是干吗用的"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" size="mini" @click="save()">保存</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
    //导入 HTTP请求方法
    import {
        savePageLink,
        getValidDictionaryList,
        getPageLink,
        getPageLinkTypeList,
        getPlatformList2
    } from '../../api/api'
    export default{
        data(){
            return {
                loading: false,
                linkId: this.$route.params.id,
                typeList: [],
                canEdit: true,
                platformData: [],
                activeTypeList: [],
                platformDisabled: this.$route.params.id == 0 ? false : true,
                pageTypeList: [{id: 1, name: '活动首页'}, {id: 0, name: '活动其他页面'}],
                form: {
                    linkId: '',
                    pageTitle: '',
                    pageLink: '',
                    linkTpye: 0,
                    activeType: -1,
                    pageLinkPara: '',
                    createTime: '',
                    remark: '',
                    platformId: 4,
                    defaultPage: 0
                },
            }
        },
        //挂载时候执行
        mounted(){
            //初始化活动类型
            this.getActiveTypeList();
            this.getAllPageLinkTypeList();
            this.getPlatfrom();
            this.initDetail();
        },
        methods: {
            initDetail(){
                if (this.linkId > 0) {
                    this.loading = true;
                    getPageLink({linkId: this.linkId}).then(res => {
                        this.loading = false;
                        console.log(res)
                        this.form = res.data.value
                        this.canEdit = false;
                    })
                }
            },
            getActiveTypeList(){
                getValidDictionaryList({
                    "platformGroupId": 1000, "dictionaryTypeId": 203, "currentPage": 1,
                    "pageSize": 50,
                }).then((res) => {
                    if (res.data.status == 200) {
                        this.loading = false;
                        this.activeTypeList = [];
                        this.activeTypeList.push({id: -1, name: '请选择活动类型'});
                        for (let v of res.data.value.list) {
                            let type = {};
                            type.id = parseInt(v.dictionaryKey);
                            type.name = v.dictionaryName;
                            this.activeTypeList.push(type);
                        }
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },
            getAllPageLinkTypeList(){
                getPageLinkTypeList().then((res) => {
                    if (res.data.status == 200) {
                        this.typeList = [];
                        for (let v of res.data.value) {
                            let type = {};
                            type.id = parseInt(v.id);
                            type.name = v.name;
                            this.typeList.push(type);
                        }
                        console.log(this.typeList);
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },
            save(){
                console.log(this.form);
                if (this.form.pageTitle == "") {
                    this.$message({
                        message: "请输入页面标题",
                        type: 'error'
                    });
                    return;
                }
                if (this.form.pageLink == "") {
                    this.$message({
                        message: "请输入页面连接",
                        type: 'error'
                    });
                    return;
                }
                if (this.form.linkTpye == 0 && this.form.activeType == -1) {
                    this.$message({
                        message: "请选择页面类型",
                        type: 'error'
                    });
                    return;
                }

                this.loading = true;
                savePageLink(this.form).then((res) => {
                    this.loading = false;
                    if (res.data.success) {
                        this.$message({
                            message: res.data.message,
                            type: 'success'
                        });
                        window.history.back();
                    } else {
                        this.$message({
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },
            linkTpyeChange(){
                if(this.form.linkTpye!=''&&this.form.linkTpye>0){
                    this.form.activeType=-1;
                    this.form.defaultPage=1
                }
            },
            activeTypeChange(){
                if(this.form.activeType>=0){
                    this.form.linkTpye=0;
                    this.form.defaultPage=0
                }
            },
            returnHistory(){
                window.history.back()
            },
            getPlatfrom(){
                //初始化首页数据
                getPlatformList2().then((res) => {
                    this.platformData = res.data;
                });
            },
        }
    }

</script>
<style>
    .p {
        color: red
    }
</style>



// WEBPACK FOOTER //
// src/views/pageconfig/pageLinkDetail.vue